const KEY = 'recentScoreLimits';
const LAST_KEY = 'lastScoreLimit';
const validLimit = (value: unknown): value is number =>
  typeof value === 'number' &&
  Number.isInteger(value) &&
  value > 0 &&
  value <= 9999;

function readRecentLimits(): number[] {
  try {
    const stored: unknown = JSON.parse(localStorage.getItem(KEY) ?? '[]');
    return Array.isArray(stored)
      ? [...new Set(stored.filter(validLimit))].slice(0, 2)
      : [];
  } catch {
    return [];
  }
}

/**
 * Two distinct numeric slots, always low to high. Recency chooses which
 * numbers appear; 500 then 250 fill an empty slot. No limit and Custom stay
 * separate controls.
 */
export function getScoreLimitPresets(): number[] {
  const last = getLastScoreLimit();
  const recent =
    last === null
      ? readRecentLimits()
      : [last, ...readRecentLimits().filter((value) => value !== last)];
  const slots = recent.length
    ? [...new Set([...recent, 500, 250])].slice(0, 2)
    : [250, 500];
  return slots.sort((a, b) => a - b);
}

/** The last applied choice, including an explicit No limit. */
export function getLastScoreLimit(): number | null {
  try {
    const value: unknown = JSON.parse(
      localStorage.getItem(LAST_KEY) ??
        localStorage.getItem('scoreLimit') ??
        'null',
    );
    return validLimit(value) ? value : null;
  } catch {
    return null;
  }
}

/** Call only after a target is applied, never while typing or navigating back. */
export function rememberScoreLimit(limit: number | null) {
  if (limit !== null && !validLimit(limit)) return;
  try {
    localStorage.setItem(LAST_KEY, JSON.stringify(limit));
    if (limit === null) return;
    localStorage.setItem(
      KEY,
      JSON.stringify(
        [limit, ...readRecentLimits().filter((n) => n !== limit)].slice(0, 2),
      ),
    );
  } catch {
    /* Optional device preferences must never block a game. */
  }
}
